import { formatDateTime } from 'core/utils/date';
import { BorderedContainer } from '../../../common/BorderedContainer';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** ドクターカー/ドクターヘリ。 */
  drCarDrHeli: IncidentDetailPatient['drCarDrHeli'];
};

/** ドクターカー/ドクターヘリのコンポーネント。 */
export const DrCarDrHeli = ({ drCarDrHeli }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="ドクターカー/ドクターヘリ" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="ドクターカー出動"
            content={drCarDrHeli?.drCarDispatch ?? ''}
          />
          <InfoDisplay
            title="医師接触日時"
            content={
              drCarDrHeli?.drCarContactAt
                ? formatDateTime(drCarDrHeli?.drCarContactAt, 'MM/dd HH:mm')
                : ''
            }
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="ドクターヘリ出動"
            content={drCarDrHeli?.drHeliDispatch ?? ''}
          />
          <InfoDisplay
            title="医師接触日時"
            content={
              drCarDrHeli?.drHeliContactAt
                ? formatDateTime(drCarDrHeli?.drHeliContactAt, 'MM/dd HH:mm')
                : ''
            }
          />
        </div>
      </div>
    </BorderedContainer>
  );
};
